import { useState } from "react";
import { api } from "@lib/orpc-client";
import { getORPCErrorMessage } from "@lib/orpc-error";
import * as Sentry from "@sentry/react";

export type PlnCustomerDetails = {
  name: string;
  segment_power: string;
  meter_no: string;
  subscriber_id: string;
};

export type PlnInquiryResponse = {
  customer_no: string;
  is_valid: boolean;
  provider_rc: string;
  provider_message: string;
  customer: PlnCustomerDetails | null;
};

export const usePlnInquiry = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const inquireCustomer = async (
    customerNo: string
  ): Promise<PlnInquiryResponse | null> => {
    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const response = await api.wallet.ppob.plnInquiry({
        customer_no: customerNo,
      });

      setIsLoading(false);
      return response;
    } catch (err) {
      setIsError(true);
      setIsLoading(false);
      setError(getORPCErrorMessage(err) || "Failed to inquire PLN customer");
      Sentry.captureException(err, {
        tags: { feature: "ppob", service: "pln-inquiry" },
        extra: { customerNo },
      });
      return null;
    }
  };

  return {
    isLoading,
    isError,
    error,
    inquireCustomer,
  };
};
